import { theme } from '@styles';

export const styles = {
  contentContainer: {
    alignItems: 'center',
    color: theme.colors.white[100],
    flexDirection: 'column',
  },
  modalContainer: {
    backdropFilter: 'blur(17px)',
    backgroundColor: 'rgba(255, 255, 255, 0.10)',
    border: `1px solid rgba(255, 255, 255, 0.10)`,
  },
};
